Namespace 'Customer.Dashboard'

class Customer.Dashboard.SummaryHeaderView extends Backbone.View
  template: JST['backbone/templates/customer/dashboard/summary/main/summary_header']

  initialize: (@options = {}) ->
    @filter = @options.filter || throw new Error('Cannot instantiate a SummaryHeaderView without a filter')
    @usersGroups = @options.usersGroups
    @users = @options.users
    @ticketAttributes = @options.conversation_attributes
    @exportableFields = @_exportableFields()
    @selectionView = new Customer.Dashboard.SummarySelectionView()
    @automaticRefreshView = new Customer.Dashboard.AutomaticRefreshView(@filter)
    @searchView = new Customer.Dashboard.SummarySearchView()
    @listenTo @searchView, 'search:settings:changed', @onChangeSearchText
    @listenTo @searchView, 'search:settings:cancelled', @onCancelSearch
    if @filter.isFilter()
      @sortingView = new Customer.Dashboard.SummarySortingView(order_by: @filter.get('query').order_by)
      @listenTo @sortingView, 'search:settings:changed', @onChangeSorting
    @exportView = new Customer.Dashboard.SummaryExportView()
    @listenTo @exportView, 'export_button:clicked', @onExportClick
    @listenTo @exportView, 'logios_export_button:clicked', @onLogiosExportClick
    @listenTo @selectionView, 'summary:select:not:loaded', @onSelectNotLoaded
    @listenTo @selectionView, 'summary:unselect:not:loaded', @unselectNotLoaded
    @canFullExportLogios = window.App.Ability.CanFullExportLogios
    @exportLogiosLimit = window.App.Configuration.ExportLogiosLimit

  render: ->
    @$el.html(@template())
    @$nonMassiveActions = @$el.find('.sorting-container, .search-container, .export-container')
    @$massiveActions = @$el.find('.massive-actions').hide()
    @$el.find('.sorting-container').append(@sortingView.render(@filter).$el)
    @$el.find('.automatic-reload-container').append(@automaticRefreshView.render().$el)
    @$el.find('.search-container').append(@searchView.render(@filter).$el)
    @$el.find('.export-container').append(@exportView.render().$el)
    @$el.find('.selection-container').append(@selectionView.render().$el)
    unless Keepcon.current_user.canUpdateAll
      @$el.find('.selection-container').css('visibility', 'hidden')
    @

  newSearchWithSettings: =>
    @trigger('search:settings:changed')

  onChangeSorting: (order_by) ->
    @_keepCustomerSessionAlive()
    @filter.get('query').order_by = order_by
    @newSearchWithSettings()

  onCancelSearch: =>
    @_keepCustomerSessionAlive()
    @trigger('search:settings:cancelled')

  onChangeSearchText: (search_text) ->
    @_keepCustomerSessionAlive()
    @filter.get('query').search_text = search_text
    @newSearchWithSettings()

  bodyTicketsLoaded:=>
    @searchView.searchFinished()
    @sortingView.render()

  getQuery: =>
    {order_by: @sortingView.getOrderBy(), search_text: @searchView.getSearchText()}

  showMassiveActions: (collection, includeNotLoaded=false) ->
    @$nonMassiveActions.hide()
    @$massiveActions.show()
    @automaticRefreshView.hide()
    @$el.find('.automatic-reload-container').css('display', 'none')
    @setMassiveActionsView(collection, includeNotLoaded)
    @bindUnselectListeners(collection)
    @bindSelectNotLoadedListeners()
    @$el.find('.massive-actions').html(@massiveActionsView.render().el)

  setMassiveActionsView: (collection, includeNotLoaded) ->
    @massiveActionsView = new Customer.Ticket.MassiveActionsView
      model: collection
      filterId: @filter.get('id')
      query: @filter.get('query')
      total: @filter.getCounter()
      usersGroups: @usersGroups
      users: @users
      includeNotLoaded: includeNotLoaded
      taxonomyAttributes: @options.taxonomy_attributes
      conversationAttributes: @options.conversation_attributes

  bindUnselectListeners: (collection) ->
    @listenTo(@massiveActionsView.massiveSelectedTicketsView, 'summary:massive:unselect', => @selectionView.unselectAll())
    @listenTo(collection, 'tickets:update_all:loading', => @selectionView.unselectAll())

  bindSelectNotLoadedListeners: ->
    @listenTo(@massiveActionsView.massiveSelectedTicketsView, 'summary:massive:select:all', @selectAll)
    @listenTo(@massiveActionsView.massiveSelectedTicketsView, 'summary:massive:select:not:loaded', @selectNotLoaded)

  selectNotLoaded: ->
    @trigger('summary:select:not:loaded')

  onSelectNotLoaded: ->
    if @massiveActionsView
      @massiveActionsView.updateMassiveCount()

  selectAll: (event) =>
    @trigger('summary:select:all', true)

  unselectNotLoaded: (event) =>
    @trigger('summary:unselect:not:loaded')

  removeMassiveActions: ->
    return if not @massiveActionsView
    @$massiveActions.hide()
    @$nonMassiveActions.show()
    @$nonMassiveActions.css('display', 'inline-block')
    @automaticRefreshView.show()
    @$el.find('.automatic-reload-container').css('display', 'inline-block')
    @unbindUnselectListeners()
    @unbindSelectNotLoadedListeners()
    @massiveActionsView.remove()
    @massiveActionsView = undefined

  unbindUnselectListeners: ->
    @stopListening(@massiveActionsView.massiveSelectedTicketsView, 'summary:massive:unselect')
    @stopListening(@massiveActionsView.model, 'tickets:update_all:loading')

  unbindSelectNotLoadedListeners: ->
    @stopListening(@massiveActionsView.massiveSelectedTicketsView, 'summary:massive:select:all')
    @stopListening(@massiveActionsView.massiveSelectedTicketsView, 'summary:massive:select:not:loaded')

  automaticRefreshActive: ->
    @automaticRefreshView.automaticRefreshActive()

  onExportClick: =>
    @_keepCustomerSessionAlive()
    return @_noTicketsToExportMessage() if @filter.getCounter() is 0
    @exportableFieldsView = new Customer.Dashboard.SummaryTicketsExportableFieldsView
      filterCount: @filter.getCounter()
      exportableFields: @exportableFields
      ticketAttributes: @ticketAttributes
    @$('.container-exportable-field').append(@exportableFieldsView.render().el)
    @listenTo(@exportableFieldsView, 'on-export-confirm', @_exportationConfirmed)
    @listenTo(@exportableFieldsView, 'on-json-export-confirm', @_jsonExportationConfirmed)
    @exportableFieldsView.showModal()

  onLogiosExportClick: =>
    action = 'customer_tickets_to_logios'
    message = ''

    $button = @$('#logios-export')

    params = _.extend(
      @_buildFilterData(@filter),
      timezone: Date.browserTimeZoneString()
    )

    @_showExportStartedMessage(@canFullExportLogios)
    @_startExportation($button, action, message, params)

  isSelectAllChecked: ->
    @selectionView.isSelectAllChecked()

  updateMassiveCountWithNotLoaded: ->
    if @massiveActionsView
      @massiveActionsView.updateCountWithNotLoaded()

  updateMassiveCountWithLoaded: (total, selected)->
    if @massiveActionsView
      @massiveActionsView.updateCountWithLoaded(total, selected)

  updateSelectionView: (totalTickets, selectedTickets) ->
    if selectedTickets == 0
      @selectionView.selectNone()
    else if selectedTickets < totalTickets
      @selectionView.selectPartially()
    else if selectedTickets == totalTickets
      @selectionView.selectAll()

  hideDisabledSelectAll: ->
    @$el.find("#disabled-select-all").addClass("d-none")

  showEnabledSelectAll: ->
    @$el.find("#summary-checkbox").removeClass("d-none")

  _noTicketsToExportMessage: ->
    swal
      title: I18n.t 'customer.dashboard.no_tickets'
      type: 'warning'
    false

  _exportationConfirmed: =>
    @_exportDataExcel('customer_tickets_to_excel', I18n.t('customer.dashboard.modal_export_fields.error'))

  _jsonExportationConfirmed: =>
    @_exportDataExcel('customer_tickets_to_json', I18n.t('customer.dashboard.modal_export_fields.error'))

  _exportDataExcel: (action, message) =>
    $button = @$('#' + action)
    return if $button.hasClass('disabled')
    params = _.extend(
      @_buildFilterData(@filter),
      fields: @_selectedFields(),
      timezone: Date.browserTimeZoneString()
    )
    @_startExportation($button, action, message, params)

  _buildFilterData: (filter) ->
    query = filter.toJSON().query
    return {query: query} unless filter.isPersisted()

    {
      filter_id: filter.id,
      additional_query: {order_by: query.order_by, search_text: query.search_text, id: query.id}
    }

  _selectedFields: ->
    [
      @exportableFieldsView.selectedFrom(@exportableFields)...
      @exportableFieldsView.selectedFrom(@ticketAttributes)...
    ]

  _startExportation: ($button, action, message, params) =>
    exportJob = new Customer.AsyncJob()
    exportJob.bind('completed', @_onComplete)
    exportJob.bind('failed', @_onFailure)
    exportJob.start action, params

  _onComplete: (result) =>
    #window.open(result.path)
    this._download(result.path)
    return false

  _download: (url)=>
    a = document.createElement("a")
    a.href = url
    a.click()

  _onFailure: =>
    swal(title: I18n.t('customer.dashboard.modal_export_fields.error'), type: "warning")
    return false

  _exportableFields: ->
    @_parsedField(field) for field in @_exportableFieldList()

  _parsedField: (field) ->
    code: field
    name: I18n.t "customer.dashboard.ticket_export_fields.#{field}"
    type: 'exportable'
    default: (field in ['id', 'status', 'assigned_to_name', 'latest_content_date', 'sub_type', 'tags'])

  _exportableFieldList: ->
    [
      'id'
      'status'
      'assigned_to_name'
      'creation_content_date'
      'first_assignation'
      'first_answer'
      'first_close'
      'first_close_delay'
      'last_close_delay'
      'first_close_calendar_delay'
      'last_close_calendar_delay'
      'latest_content_date'
      'proper_type'
      'sub_type'
      'interaction_count'
      'brand_interaction_count'
      'closed_count'
      'assignation_count'
      'tags'
      'labels'
      'history'
      'notes'
      'social_user'
      'social_network_user_id'
      'username'
      'social_network_author_name'
    ]

  _keepCustomerSessionAlive:->
    Backbone.trigger 'customerSession:keepAlive'

  _showExportStartedMessage: (no_limit) =>
    if no_limit
      swal
        title: I18n.t 'customer.reports.modal.export_started_title'
        text: I18n.t 'customer.reports.modal.export_started_message'
        type: 'info'
        html: true
    else
      ltext = I18n.t 'customer.reports.modal.export_limit_started_message'
      limit_text = ltext + " " + @exportLogiosLimit + " tickets"

      swal
        title: I18n.t 'customer.reports.modal.export_limit_started_title'
        text:  limit_text
        type: 'info'
        html: true
